//--------------------------------------------------------------------------------------------------Imports
import { Button, Col, Input, Row } from "antd";
import { RequestEmailnorton, RequestUpdateSuscriptor, ResponsePackageItem } from "../../../types/common";
import { StyleSheet } from "../../../StyleSheet";
import { useCallback, useEffect, useState } from "react";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";
import { useDispatch, useSelector } from "react-redux";
import { fillGeneralDataSlice, getGeneralData } from "../../../stores/slices/generalDataSlice";
import { clearInternetSeguroData } from "../../../stores/slices/internetSeguroSlice";
import { eventLog, hireNorton, hireService, sendVerificationCode, updateSuscriptor, validateSubscription } from "../../../methods/Methods";
import _ from "lodash";
import { AppDispatch } from "../../../stores/store";
import { clearAlert, setAlert, showAlert } from "../../../stores/slices/alertSlice";
import SwipeableButton from "../../../components/SwipeableButton";
// import { clearBloquedDialog, /*setBloquedDialog,*/ showBloquedDialog } from "../../../stores/slices/bloquedDialogSlice";
import { getCount, setCount } from "../../../stores/slices/countSlice";

//-------------------------------------------------------------------------------------------------- Interface
interface HireServicesComponentProps {
    packageSrv: ResponsePackageItem;
};

const NAVEGACION_SEGURA_PACKAGE_NAME = "Mega Navegación Segura";

//-------------------------------------------------------------------------------------------------- Component
const HireServicesComponent = (props: HireServicesComponentProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedContract } = useSelector(getGeneralData);
    const { count } = useSelector(getCount);

    const verificationCodeText = "# Ha sido enviado un código de verificación para la contración del servicio vía SMS. | Código de verificación";
    // Control
    const [state, setState] = useState<number>(0);
    const [resetSwip, setResetSwip] = useState<boolean>(false);
    // Data
    const [clientId, setClientId] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [emailConfirmation, setEmailConfirmation] = useState<string>("");
    const [verificationCode, setVerificationCode] = useState<string>("");
    const { packageSrv } = props;
    const isNavegacionSeguraPackage = packageSrv.name === NAVEGACION_SEGURA_PACKAGE_NAME;

    const handleChangeVerCode = (value: string) => {
        if (value.length < 6) {
            return false;
        }

        return true;
    };

    const handleFinalizeAlert = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const validateEmail = (inputString: string) => {
        let valid = false;
        var reg = RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.([a-zA-Z]{2,4})+$");
        var result = reg.test(inputString);
        if (result) {
            valid = true;
        } else {
            valid = false;
        }
        return valid;
    };

    const hireNortonEmail = useCallback(async (): Promise<boolean> => {
        let objEmail = {
            email: email
        } as RequestEmailnorton;

        try {
            const nortonResponse = await hireNorton(objEmail, clientId);

            if (!nortonResponse.data[0].estatus) {
                dispatch(setAlert({
                    show: true,
                    title: "¡Estimado usuario!",
                    message: nortonResponse.data[0].mensaje || "No fue posible registrar su correo electrónico, intentelo más tarde.",
                    type: "ERROR",
                    onFinalize: handleFinalizeAlert
                }));
                return false;
            }

            return true;
        } catch {
            dispatch(setAlert({
                show: true,
                title: "¡Estimado usuario!",
                message: "No fue posible registrar su correo electrónico, intentelo más tarde.",
                type: "ERROR",
                onFinalize: handleFinalizeAlert
            }));
            return false;
        }
    }, [email, clientId, dispatch, handleFinalizeAlert]);

    const sendVerificationCodeToMega = useCallback(async (service: string) => {
        let error = false;
        let message = "";
        let show = false;
        
        await sendVerificationCode(clientId, "contratacion", service)
            .then((response) => {
                if (response.data[0]) {
                    if (response.data[0].estatus && _.isEqual(response.data[0].estatus, "true")) {
                        message = "Ha sido enviado un código de verificación para la contratación del servicio vía SMS.\nFavor de confirmarlo en el siguiente paso."
                        setState(2);
                    } else if (response.data[0].codigo === "2") {
                        error = true;
                        message = "Ha ocurrido un error en el envío de su código de verificación vía SMS, intentarlo más tarde.";
                        setState(0);
                    } else if (response.data[0].codigo === "3") {
                        error = true;
                        message = "Ha llegado a su límite de intentos de contratación en el día, intentarlo el día de mañana.";
                        setState(0);
                    } else {
                        error = true;
                        message = "Ha ocurrido un error al generar su código de verificación, intentarlo más tarde.";
                        setState(0);
                    }
                    show = true;
                }
            })
            .catch(() => {
                error = true;
                message = "Ha ocurrido un error al generar su código de verificación, intentarlo más tarde.";
                show = true;
                setState(0);
            });

        dispatch(setAlert({
            show: show,
            title: "¡Estimado Usuario!",
            message: message,
            type: (error) ? "ERROR" : "SUCCESS",
            onFinalize: handleFinalizeAlert
        }));
    }, [clientId, dispatch, handleFinalizeAlert]);

    const updateNavegacionSeguraEmail = useCallback(async (service: string) => {
        try {
            const updateResponse = await updateSuscriptor({ code: "", email, phone: "" } as RequestUpdateSuscriptor, clientId);

            if (!updateResponse.data.data[0].success) {
                dispatch(setAlert({
                    show: true,
                    title: "¡Estimado Usuario!",
                    message: updateResponse.data.data[0].message || "No fue posible actualizar su correo electrónico, intentelo más tarde.",
                    type: "ERROR",
                    onFinalize: handleFinalizeAlert
                }));
                return;
            }
        } catch {
            dispatch(setAlert({
                show: true,
                title: "¡Estimado Usuario!",
                message: "No fue posible actualizar su correo electrónico, intentelo más tarde.",
                type: "ERROR",
                onFinalize: handleFinalizeAlert
            }));
            return;
        }

        dispatch(fillGeneralDataSlice({ clientId }));
        await sendVerificationCodeToMega(service);
    }, [email, clientId, dispatch, handleFinalizeAlert, sendVerificationCodeToMega]);

    const handleHireService = (service: string) => {
        if (packageSrv.onConfirmButton.emailRequired) {
            let error = true;
            let errorMessage = "";

            if (_.isEmpty(email)) {
                error = true;
                errorMessage = "El correo electrónico no puede estar vacío.\nColoque su correo electrónico e intente nuevamente.";
            }
            else if (!validateEmail(email)) {
                error = true;
                errorMessage = "Formato de correo electrónico incorrecto.\nAsegúrese que el correo está bien escrito e intente nuevamente.";
            }
            else if (_.isEmpty(emailConfirmation)) {
                error = true;
                errorMessage = "La confirmación del correo electrónico no puede estar vacía.\nLlene el campo e intente nuevamente.";
            }
            else if (!validateEmail(emailConfirmation)) {
                error = true;
                errorMessage = "Formato del correo electrónico de confirmación incorrecto.\nAsegúrese que el correo está bien escrito e intente nuevamente.";
            }
            else if (email.trim() !== emailConfirmation.trim()) {
                error = true;
                errorMessage = "El correo electrónico de confirmación no coincide con el correo otorgado.\nAsegúrese que el correo está bien escrito e intente nuevamente.";
            }
            else {
                error = false;
            }

            if (error) {
                dispatch(setAlert({
                    title: "Correo inválido",
                    show: true,
                    message: errorMessage,
                    type: "ERROR",
                    onFinalize: handleFinalizeAlert
                }));
            }
            else if (isNavegacionSeguraPackage) {
                updateNavegacionSeguraEmail(service);
            }
            else {
                sendVerificationCodeToMega(service);
            }
        }
        else {
            sendVerificationCodeToMega(service);
        }
    };

    const handleSwipeHire = useCallback(async () => {
        let message = "";
        let success = false;
        setResetSwip(false);

        if (handleChangeVerCode(verificationCode)) {
            let objDataToHire = {
                id_paquete: packageSrv.idPackage,
                promocion: parseInt(packageSrv.promotion),
                nombrePaquete: packageSrv.name,
                codigo_validacion: verificationCode
            };

            let objDataValidate = {
                id_paquete: packageSrv.idPackage,
                promocion: packageSrv.promotion,
            };

            let objEventLog = {
                tipoServicio: packageSrv.serviceType,
                servicio: packageSrv.service,
                promocion: packageSrv.promotion,
                accion: "Contratacion",
                // Si fue contratacion con email requerido. se manda el email, sino se manda vacio
                correo: packageSrv.onConfirmButton.emailRequired ? email : ""
            };

            if (packageSrv.onConfirmButton.emailRequired && !isNavegacionSeguraPackage) {
                const nortonSuccess = await hireNortonEmail();

                if (!nortonSuccess) {
                    setResetSwip(true);
                    return;
                }
            }

            await validateSubscription(objDataValidate, clientId)
                .then(async (response) => {
                    // Se puede proceder con la contratacion
                    if (response.data[0].resultado === "1") {
                        // Metodo de contratación
                        await hireService(objDataToHire, clientId)
                            .then((response) => {
                                // Se hizo correctamente la contratación
                                if (response.data[0].id && !_.isEmpty(response.data[0].id)) {
                                    // Dispatch para volver a consultar los servicios y actualizar estatus.
                                    dispatch(setCount({ count: count + 1 }));
                                    if (isNavegacionSeguraPackage) {
                                        // Se limpia el caché de Internet Seguro para que Control Parental
                                        // vuelva a consultar el entitlement/perfil en vez de quedarse con
                                        // el estado de antes de contratar.
                                        dispatch(clearInternetSeguroData());
                                    }
                                    // Metodo para llamar a los logs
                                    eventLog(objEventLog, clientId);
                                    message = response.data[0].mensaje;
                                    success = true;
                                } else {
                                    message = response.data[0].mensaje;
                                    success = false;
                                }
                            })
                            .catch(() => {
                                message = "No es posible realizar la contratación, intentelo más tarde.";
                                success = false;
                            });
                    } else if (response.data[0].codigo === "2") {
                        // Ya tiene una contratacion en proceso
                        message = "No es posible continuar con la contratación, ya cuenta con una en proceso.";
                        success = false;
                    } else {
                        message = "Ha ocurrido un error al validar su contratación, intentarlo más tarde.";
                        success = false;
                    }
                })
                .catch((response) => {
                    message = "Ha ocurrido un error al validar su contratación, intentarlo más tarde.";
                    success = false;
                });
        } else {
            message = "El código de verificación debe contener 6 dígitos";
            success = false;
        }

        dispatch(setAlert({
            show: true,
            title: "¡Estimado usuario!",
            message: message,
            type: success ? "SUCCESS" : "ERROR",
            onFinalize: handleFinalizeAlert
        }));

        if (!success) {
            setResetSwip(true);
        }

    }, [dispatch, handleFinalizeAlert, clientId, email, hireNortonEmail, isNavegacionSeguraPackage, packageSrv, verificationCode, count]);

    useEffect(() => {
        // Solo se toma una vez, al montar: si más adelante selectedContract cambia por
        // un efecto colateral (ej. fillGeneralDataSlice regresando al contrato principal
        // tras actualizar el correo), no se debe reasignar clientId a media contratación.
        if (selectedContract && !clientId) {
            setClientId(selectedContract.sucursal + selectedContract.suscriptor);
        }
    }, [selectedContract, clientId]);

    const renderStateZero = () => (
        <>
            <Col span={18} style={styles.mdContainer}>
                <MarkdownPreviewer
                    h1Style={{
                        fontSize: 15,
                        color: "#000000",
                        fontWeight: 700
                    }}
                    h2Style={{
                        fontSize: 12,
                        color: "#707070",
                        fontWeight: 500
                    }}
                    h3Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    h4Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    textStyle={{
                        fontSize: 10,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                    }}
                    linkStyle={{
                        fontSize: 12,
                        color: "#000000",
                        textDecoration: "underline",
                    }}
                    mdSource={packageSrv.onHireButton.mdContent}
                />
            </Col>
            <Col span={6} style={styles.buttonContainer}>
                <Button style={styles.buttonStyle} onClick={() => setState(1)}>{packageSrv.onHireButton.buttonTitle}</Button>
            </Col>
        </>
    );

    const renderStateOne = () => (
        <>
            <Col span={24} style={styles.mdContainer}>
                {(packageSrv.onConfirmButton.emailRequired) && (
                    <>
                        <p style={{
                            fontSize: 12,
                            color: "#000000",
                            padding: 0,
                            margin: "0px 0px 10px 0px",
                        }}>
                            Para crear su cuenta es necesario que registre su correo electrónico.
                        </p>
                        <Input
                            style={{ marginBottom: 20 }}
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <Input
                            style={{ marginBottom: 10 }}
                            placeholder="Confirma el correo electrónico"
                            value={emailConfirmation}
                            onChange={(e) => setEmailConfirmation(e.target.value)}
                        />
                    </>
                )}
            </Col>
            <Col span={18} style={styles.mdContainer}>
                <MarkdownPreviewer
                    h1Style={{
                        fontSize: 15,
                        color: "#000000",
                        fontWeight: 500
                    }}
                    h2Style={{
                        fontSize: 12,
                        color: "#707070",
                        fontWeight: 500
                    }}
                    h3Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    h4Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    textStyle={{
                        fontSize: 10,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                    }}
                    linkStyle={{
                        fontSize: 12,
                        color: "#000000",
                        textDecoration: "underline",
                    }}
                    mdSource={packageSrv.onConfirmButton.mdContent}
                />
            </Col>
            <Col span={6} style={styles.buttonContainer}>
                <Row>
                    <Col span={24}>
                        <Button style={styles.buttonStyle} onClick={() => handleHireService(packageSrv.serviceType)}>{packageSrv.onConfirmButton.buttonTitle}</Button>
                    </Col>
                    <Col span={24}>
                        <Button style={styles.buttonCancelStyle} onClick={() => setState(0)}>Cancelar</Button>
                    </Col>
                </Row>
            </Col>
        </>
    );

    const renderStateThree = () => (
        <Col span={24}>
            <MarkdownPreviewer
                h1Style={{
                    textAlign: "center",
                    fontSize: 12,
                    color: "#000000",
                    fontWeight: 500
                }}
                textStyle={{
                    fontWeight: 600,
                    fontSize: 12,
                    textAlign: "center",
                }}
                mdSource={verificationCodeText}
            />
            <Input
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value.replace(/[^0-9]/g, ""))}
                maxLength={6}
                placeholder="XXXXXX"
                style={{ textAlign: "center", marginBottom: 20 }}
            />
            <SwipeableButton
                resetStatus={resetSwip}
                onSuccess={handleSwipeHire}
                color='#0055c2'
                text='Deslice para confirmar'
            />
        </Col>
    );

    return ((state === 0) ? (
        renderStateZero()
    ) : ((state === 1) ? (
        renderStateOne()
    ) : (
        renderStateThree()
    )));
};

const styles = StyleSheet.create({
    mdContainer: {
        paddingRight: 10,
    },
    buttonContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    buttonStyle: {
        height: 30,
        fontSize: 10,
        fontWeight: 600,
        padding: "0px 10px 0px 10px",
        borderRadius: 20,
        border: "none",
        marginBottom: 10,
        marginTop: 10,
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    buttonCancelStyle: {
        height: 30,
        fontSize: 10,
        fontWeight: 600,
        padding: "0px 10px 0px 10px",
        borderRadius: 20,
        border: "none",
        marginBottom: 10,
        marginTop: 10,
        color: "#ffffff",
        backgroundColor: "gray",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default HireServicesComponent;
